import { Notifier } from "@pionglobal/pionsharedui";
import React from "react";
import ErrorNotifier from "./ErrorNotifier";

const CommonMessagesPage = ({ messageArray = [], ...props }) => {
  // Extract logic before JSX
  const filteredMessages = React.useMemo(() => {
    return messageArray.filter(item =>
      item && (item?.message || item?.errMessage)
    );
  }, [messageArray]);

  // Early return if no messages
  if (!filteredMessages.length) {
    return null; // or <div>No messages</div>
  }

  return (
    <div>
      {filteredMessages.map((item, index) => (
        <span key={item.id || index}>
          {item?.message && <Notifier message={item.message} />}
          {item?.errMessage && <ErrorNotifier message={item.errMessage} />}
        </span>
      ))}
    </div>
  );
};

export default CommonMessagesPage;